import { Director, director, EventTarget, Game, game } from 'cc';

export enum EventType {
    IS_IDLE_STATE_CHANGED = 'IS_IDLE_STATE_CHANGED',
    ELAPSED_TIME_CHANGED = 'ELAPSED_TIME_CHANGED',
}

export default class IdleTimer extends EventTarget {
    public static readonly EVENT_TYPE = EventType;

    private _elapsedTime = 0;
    private _isIdle = false;

    constructor(idleWhenHiding: boolean) {
        super();
        director.on(Director.EVENT_AFTER_UPDATE, () => {
            if (this.isIdle) {
                this.elapsedTime += game.deltaTime;
            } else {
                this.elapsedTime = 0;
            }
        });
        if (idleWhenHiding) {
            let startHidingTime = -1;
            game.on(Game.EVENT_HIDE, () => {
                startHidingTime = Date.now();
            });
            game.on(Game.EVENT_SHOW, () => {
                if (this.isIdle && startHidingTime !== -1) {
                    this.elapsedTime += (Date.now() - startHidingTime) / 1000;
                }
            });
        }
    }

    public get isIdle() {
        return this._isIdle;
    }
    public set isIdle(value: boolean) {
        if (this._isIdle === value) {
            return;
        }
        this._isIdle = value;
        this.emit(EventType.IS_IDLE_STATE_CHANGED, this._isIdle);
    }

    public get elapsedTime() {
        return this._elapsedTime;
    }
    public set elapsedTime(value: number) {
        if (value === this._elapsedTime) {
            return;
        }
        this._elapsedTime = value;
        this.emit(EventType.ELAPSED_TIME_CHANGED, this._elapsedTime);
    }

    public reset() {
        this.isIdle = false;
        this.elapsedTime = 0;
    }
}
